import React, {useState,useRef, useEffect} from "react";
import "./termsConditions.css";

const TermsAndConditions = () =>{
    const [isOpen, setIsOpen] = useState(true); // Set default state to true (popup open)
    const modalRef = useRef(null); // Reference for the modal
    const closeButtonRef = useRef(null); // Reference for the close button

    // Function to close the modal
const handleClose = () => {
  setIsOpen(false); // Set state to false to close the modal
};

  // Function to handle clicks outside the modal
  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target) && !closeButtonRef.current.contains(event.target)) {
      handleClose(); // Close the modal if the click is outside
    }
  };

  useEffect(() => {
    // Add the event listener on component mount
    document.addEventListener("mousedown", handleOutsideClick);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

    return(
        <>
        {isOpen && (
        
       <div className="termAndCondition" ref={modalRef}>
           <div className="close-button-tac" ref={closeButtonRef}>
                       <button className="close-popup-btn-tac" onClick={handleClose} >
                       ✖
                       </button>
           </div>
           <div className="heading-termAndCondition">
               <h1>TERMS & CONDITIONS</h1>
           </div>
           <div className="termAndCondition-content">
           <div className="about-tac">
                <p>Welcome to Pixwala.com. These Terms and Conditions govern your use of our website and the services we provide. By accessing or using this website, you agree to be bound by these terms. If you do not agree with any part of these terms, please refrain from using our website.</p>
             </div>

             <div className="bulletPoints">
                    <div className="heading-bulletPoints">
                    Services Provided
                    </div>
                    <div className="data-bulletPoints" >
                        <p>Pixwala offers a range of digital services, including but not limited to:</p>
                        <ol className=" custom-list custome-list-1">    
                            <li><span>Graphic designing</span></li>
                            <li><span>Video editing</span></li>
                            <li><span>Social media management</span></li>
                            <li><span>Website development</span></li>
                            <li><span>App development</span></li>
                            <li><span>Event shoots</span></li>
                            <li><span>Portfolio showcase and other digital services.</span></li>
                        </ol>
                    </div>

                    <div className="heading-bulletPoints">
                    User Obligations
                    </div>
                    <div className="data-bulletPoints" >
                        <p>By using our website, you agree to:</p>
                        <ol className=" custom-list custome-list-2">
                             <li><span>Provide accurate, current, and complete information when requested.</span></li>
                             <li><span>Use the website only for lawful purposes and in compliance with applicable laws</span></li>
                             <li><span>Not engage in any activity that may disrupt or harm the functionality of the website.</span></li>
                        </ol>
                    </div>

                    <div className="heading-bulletPoints">
                    Intellectual Property
                    </div>
                    <div className="data-bulletPoints" >
                        <p>All content on Pixwala.com, including text, images, logos, graphics, and any other materials, are the property of Pixwala and are protected by intellectual property laws. You may not use, copy, or distribute any of this content without prior written consent from Pixwala.</p>
                        {/* <ol className=" custom-list custome-list-3"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Service Availability
                    </div>
                    <div className="data-bulletPoints" >
                        <p>While we strive to provide uninterrupted access to our services, we do not guarantee that the website will be available at all times. We reserve the right to modify, suspend, or discontinue any part of the website or services without prior notice.</p>
                        {/* <ol className=" custom-list custome-list-4"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Payment and Billing
                    </div>
                    <div className="data-bulletPoints" >
                        <p>For certain services, payments may be required. All payments are processed securely. By using our services, you agree to provide accurate billing information and authorize us to charge the agreed-upon amounts for services rendered.</p>
                        {/* <ol className=" custom-list custome-list-5"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Privacy
                    </div>
                    <div className="data-bulletPoints" >
                        <p>We respect your privacy. For information on how we collect, use, and protect your personal data, please refer to our Privacy Policy.</p>
                        {/* <ol className=" custom-list custome-list-6"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Limitation of Liability
                    </div>
                    <div className="data-bulletPoints" >
                        <p>Pixwala is not liable for any direct, indirect, incidental, special, or consequential damages arising from the use of our website or services, including but not limited to errors, omissions, or any losses caused by reliance on the content provided.</p>
                        {/* <ol className=" custom-list custome-list-7> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Third-Party Links
                    </div>
                    <div className="data-bulletPoints" >
                        <p>Our website may contain links to third-party websites. These links are provided for your convenience, but we do not endorse or control the content of these external sites. We are not responsible for the privacy practices or content of third-party websites.</p>
                        {/* <ol className=" custom-list custome-list-8> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Amendments
                    </div>
                    <div className="data-bulletPoints" >
                        <p>We reserve the right to update or modify these Terms and Conditions at any time without prior notice. All changes will be effective upon posting on this page, and the "Effective Date" at the top of this document will reflect the latest update.</p>
                        {/* <ol className=" custom-list custome-list-9> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Termination
                    </div>
                    <div className="data-bulletPoints" >
                        <p>We may suspend or terminate your access to the website and services at our discretion, especially if we believe you have violated any part of these Terms and Conditions.</p>
                        {/* <ol className=" custom-list custome-list-10> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Governing Law
                    </div>
                    <div className="data-bulletPoints" >
                        <p>These Terms and Conditions are governed by the laws of [Insert Jurisdiction/Country]. Any disputes will be subject to the exclusive jurisdiction of the courts in [Insert Jurisdiction].</p>
                        {/* <ol className=" custom-list custome-list-11> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Contact Information 
                    </div>
                    <div className="data-bulletPoints" >
                    <p>If you have any questions regarding these Terms and Conditions, please contact us at:</p>
                    <ol className="custom-list custome-list-12">
                            <li><span><strong>Email: </strong>contact@pixwala.com</span></li>
                            <li><span><strong>Phone: </strong>+91 86996-21455</span></li>
                            <li><span><strong>WhatsApp: </strong>+91 86996-21455</span></li>
                        </ol>
                    </div>


             </div>

           </div>
       </div>
       )}
       </>
    );
};
export default TermsAndConditions;